import { t_key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISchedulerStudentPlan } from '../interfaces/scheduler_student_plan';

export class SchedulerStudentPlan implements ISchedulerStudentPlan {
  static build(sectionLabel: ISchedulerStudentPlan) {
    return new SchedulerStudentPlan(sectionLabel);
  }
  id: t_key;
  name: string;
  acknowledged_by_student: null | boolean;
  advisor_sent_ts: null | string;
  comments: null | string[];
  created_by: ISchedulerStudentPlan['created_by'];
  created_ts: string;
  display_title: string;
  is_advisor_latest: boolean;
  is_created_by_student: boolean;
  is_deletable: boolean;
  is_editable: boolean;
  is_primary: boolean;
  marked_done_by_student: null | boolean;
  status: null | string;
  student_data: ISchedulerStudentPlan['student_data'];
  title: string;

  constructor(sectionLabel: ISchedulerStudentPlan) {
    _4.merge(this, sectionLabel);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/builders/scheduler_student_plan.ts